import { lazy } from "react";

export const SignUpAsync = lazy(() => import("./SignUp"));
